import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import packageInfo from '../../../../../../../package.json';
import { environment } from '../../../../../../environments/environment';
import { Observable } from 'rxjs';
import {
    ApiServiceInterface,
    FormServiceInterface,
    OfflineQueue,
    OfflineServiceInterface,
    ThemeServiceInterface,
    ToastService,
    UserAccountInterface,
    UserServiceInterface,
} from '@hutsix/ngxh6';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NavbarComponent {
    public env: string = environment.env;
    public version: string = packageInfo.version + (environment.env === 'staging' ? '-staging' : '');
    public offlineQueue$: Observable<OfflineQueue[]>;

    constructor(
        public router: Router,
        public toastr: ToastService,
        @Inject('UserService') public userService: UserServiceInterface,
        @Inject('FormService') public formService: FormServiceInterface,
        @Inject('OfflineService') public offline: OfflineServiceInterface,
        @Inject('ApiService') public api: ApiServiceInterface,
        @Inject('ThemeService') public themeService: ThemeServiceInterface,
        public cdRef: ChangeDetectorRef,
    ) {
        this.offlineQueue$ = this.offline.getOfflineQueue();
    }

    update(): void {
        this.offlineQueue$ = this.offline.getOfflineQueue();
    }

    clearCaches(): void {
        if (!confirm('All cached data will be removed. You will be required to re-sync to use offline capabilities. Are you sure?')) return;

        this.api.clearCaches().subscribe(res => {
            if (res) {
                this.toastr.success('Caches cleared!');
            } else {
                this.toastr.error('Try again.', 'Something went wrong.');
            }
        });
    }
}
